<template>
  <div class="login-form">
    <!-- 登录表单 -->
    <div v-if="formMode === 'login'">
      <div class="form-header">
        <h2>Sign in to your account</h2>
        <!-- <p>Choose your preferred login method</p> -->
      </div>
    
    <!-- 登录方式选择器 -->
    <!-- <div class="login-method-selector">
      <div 
        :class="['method-option', { 'active': loginMethod === 'password' }]"
        @click="loginMethod = 'password'"
      >
        <i class="el-icon-lock"></i>
        <span>Password</span>
      </div>
      <div 
        :class="['method-option', { 'active': loginMethod === 'sms' }]"
        @click="loginMethod = 'sms'"
      >
        <i class="el-icon-message"></i>
        <span>SMS Code</span>
      </div>
    </div> -->

    <!-- 账号输入 -->
    <!-- 密码登录模式：统一输入框 -->
    <div class="input-box" v-if="loginMethod === 'password'">
      <div class="shadow-box full-width">
        <input 
          class="input" 
          v-model="form.email" 
          placeholder="Email address or phone number" 
          type="text" 
        />
      </div>
    </div>

    <!-- SMS登录模式：手机号输入（带区号） -->
    <div class="input-box" v-if="loginMethod === 'sms'">
      <div class="area-box">
        <PhoneBtn v-model="form.code"></PhoneBtn>
      </div>
      <div class="shadow-box">
        <input 
          class="input" 
          v-model="form.phone" 
          @keyup="form.phone=form.phone.replace(/\D/g,'')" 
          placeholder="phone number" 
          type="tel" 
        />
      </div>
    </div>

    <!-- 密码输入（仅在密码登录模式下显示） -->
    <div class="input-box" v-if="loginMethod === 'password'">
      <div class="shadow-box full-width">
        <input 
          class="input" 
          v-model="form.password" 
          :type="showPassword ? 'text' : 'password'"
          placeholder="Your password" 
          @keyup.enter="handleLogin"
        />
        <i 
          class="el-icon-view password-toggle"
          :class="{ 'show': showPassword }"
          @click="showPassword = !showPassword"
        ></i>
      </div>
      <!-- 忘记密码链接 - 移动到密码输入框右下方 -->
      <div class="forgot-password-link" @click="showForgotPassword">
        Forgot Password?
      </div>
    </div>

    <!-- 验证码输入（仅在SMS模式下显示） -->
    <div class="input-box" v-if="loginMethod === 'sms'">
      <div class="shadow-box full-width">
        <input 
          class="input" 
          v-model="form.verCode" 
          @keyup="form.verCode=form.verCode.substring(0,4)" 
          placeholder="Verification Code" 
          type="text"
        />
      </div>
    </div>


    <!-- 登录按钮 -->
    <div 
      :class="['sign-btn','flex-row-center',{'disable-btn':!canLogin || loginLoading}]" 
      @click="handleLogin"
    >
      <i v-if="loginLoading" class="el-icon-loading" style="margin-right: 8px;"></i>
      {{ loginMethod === 'sms' ? 'Send Verification Code' : 'Login' }}
    </div>

    <!-- <div @click="gotoBindPhone">bindphone</div> -->
    
    <!-- SMS模式下的确认按钮 -->
    <div class="flex-row-center being-send" @click="gotCode()" v-if="loginMethod === 'sms'">
      I've got the code
    </div>
    
    <!-- 第三方登录 -->
    <div class="social-login-section">
      <div class="divider">
        <span>or</span>
      </div>
      <div class="social-login-buttons">
        <GoogleLogin :fromPage="fromPage" @loginDone="handleGoogleLoginDone" @needBindPhone="handleNeedBindPhone" @needAlternativeLogin="handleNeedAlternativeLogin" />
        <AppleLogin :fromPage="fromPage" @loginDone="handleAppleLoginDone" @needBindPhone="handleNeedBindPhone" @needAlternativeLogin="handleNeedAlternativeLogin" />
        <FacebookLogin :fromPage="fromPage" @loginDone="handleFacebookLoginDone" @needBindPhone="handleNeedBindPhone" @needAlternativeLogin="handleNeedAlternativeLogin" />
      </div>
    </div>
    
    <!-- 底部链接区域 -->
    <div class="bottom-links-container">
      <!-- 注册链接 -->
      <div class="signup-link-container">
        <span>Don't have an account? </span>
        <span class="signup-link" @click="switchToSignup">Sign Up</span>
      </div>
      
      <!-- 协议说明 -->
      <div class="terms-notice">
        By logging in, I accept the 
        <a href="/termsConditions" class="under-line">Terms & Conditions</a>
        & 
        <a href="/faqs" class="under-line">Privacy Policy</a>
      </div>
    </div>
    </div>

    <!-- 注册表单 -->
    <div v-if="formMode === 'signup'">
      <SignupForm 
        :fromPage="fromPage"
        :compact="true"
        @signupSuccess="handleSignupSuccess"
      />
      
      <!-- 底部链接区域 -->
      <div class="bottom-links-container">
        <!-- 登录链接 -->
        <div class="signup-link-container">
          <span>Already have an account? </span>
          <span class="signup-link" @click="switchToLogin">Sign In</span>
        </div>
      </div>
    </div>

    <!-- 忘记密码弹窗 -->
    <ForgotPassword 
      v-if="showForgotPasswordModal"
      @close="closeForgotPassword"
    ></ForgotPassword>

    <!-- Cloudflare 验证弹层 -->
    <div v-if="showCloudflare && $cloudflareVerify" class="cloudflare-modal">
      <div class="cloudflare-overlay" @click="closeCloudflare"></div>
      <div class="cloudflare-content">
        <div class="cloudflare-header">
          <h3>Security Verification</h3>
          <button class="close-btn" @click="closeCloudflare">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <CloudflareVerify 
          style="padding: 20px;" 
          ref="cloudflare"
          @token-received="onTokenReceived"
        ></CloudflareVerify>
      </div>
    </div>

    <!-- 验证码滑块模块 -->
    <Verify 
      v-if="!$cloudflareVerify"
      @success="sendcodeMsg"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>


<script>
/* eslint-disable */ 
import { postGateway } from '@/request';
import PhoneBtn from '@/components/PhoneBtn.vue';
import Verify from '@/components/Verifition/Verify';
import CloudflareVerify from '@/components/CloudFlareVerify.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import GoogleLogin from '@/components/GoogleLogin.vue';
import FacebookLogin from '@/components/FacebookLogin.vue';
import AppleLogin from '@/components/AppleLogin.vue';
import SignupForm from '@/components/SignupComps/SignupForm.vue';
import bus from '@/utils/bus.js';

export default {
  name: 'LoginForm',
  components: {
    PhoneBtn,
    Verify,
    CloudflareVerify,
    ForgotPassword,
    GoogleLogin,
    FacebookLogin,
    AppleLogin,
    SignupForm
  },
  props: {
    fromPage: {
      type: String,
      default: 'login'
    }
  },
  data() {
    return {
      form: {
        phone: '',
        code: (this.$isUk ? '+44' : '+353'),
        verCode: '', // 手机验证码
        password: '', // 密码
        email: '', // 邮箱
      },
      canGetCode: true,
      sendPhonecode: 'Send Verification Code',
      num: 0,
      secondSend: 0,
      loginMethod: 'password', // 登录方式：sms 或 password
      showPassword: false, // 是否显示密码
      showCloudflare: false, // 是否显示Cloudflare验证
      loginLoading: false, // 登录按钮loading状态
      showForgotPasswordModal: false, // 显示忘记密码弹窗
      formMode: 'login', // 表单模式：login 或 signup
      signupForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone: '',
        verCode: '',
        invitationCode: ''
      }
    }
  },
  computed: {
    canLogin() {
      
      if (this.loginMethod === 'password') {
        if (!this.form.email.trim()) return false;
        return this.form.password.trim() !== '';
      } else {
        if (!this.form.phone.trim()) return false;
        return this.canGetCode;
      }
    }
  },
  methods: {
    gotoBindPhone() {
      this.$router.replace('/bind-phone?from=login');
    },
    // 处理登录按钮点击
    handleLogin() {
      if (this.loginMethod === 'sms') {
        this.showCaptcha();
      } else {
        this.loginWithPassword();
      }
    },
    
    // 密码登录
    async loginWithPassword() {
      if (!this.form.email.trim()) {
        this.$message({
          message: 'Please enter email or phone number',
          type: 'warning',
          offset: 50
        });
        return;
      }
      if (!this.form.password.trim()) {
        this.$message({
          message: 'Please enter password',
          type: 'warning',
          offset: 50
        });
        return;
      }

      this.setLoginLoading(true);
      
      try {
        const resp = await postGateway({
          url: '/login',
          method: 'POST',
          data: {
            userName: this.form.email,
            password: this.$encryptByPublicKey(this.form.password),
            client: 'webApi',
            captcha: ''
          }
        });

        this.setLoginLoading(false);
        if (resp.data.token) {
          this.handleLoginSuccess(resp.data);
        }
        console.log(resp, '密码登录回调');
      } catch (err) {
        this.$message.error(err.msg || 'Login failed');
        this.setLoginLoading(false);
      }
    },
    
    // 显示验证滑块
    async showCaptcha() {
      // 基础验证
      if (!this.form.phone.trim()) {
        this.$message({
          message: 'Please enter phone number',
          type: 'warning',
          offset: 50
        });
        return;
      }

      // 校验手机号是否重复国家代码
      if (!this.validatePhoneNumber()) {
        return;
      }


      // 如果正在倒计时，显示友好提示
      if (!this.canGetCode) {
        this.$message({
          message: `Please wait ${this.num} seconds before requesting again`,
          type: 'info',
          offset: 50
        });
        return;
      }

      // 根据配置选择验证方式
      if (this.$cloudflareVerify) {
        // 使用 Cloudflare 验证
        this.showCloudflare = true;
      } else {
        // 使用滑块验证
        this.$refs.verify.show();
      }
    },
    
    // 校验手机号是否重复国家代码（仅针对 +44 和 +353）
    validatePhoneNumber() {
      const phoneNumber = this.form.phone.trim();
      
      // 只处理 +44 和 +353 的情况
      if (this.form.code === '+44' && phoneNumber.startsWith('44')) {
        this.$message({
          message: "Please remove the country code '44' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      if (this.form.code === '+353' && phoneNumber.startsWith('353')) {
        this.$message({
          message: "Please remove the country code '353' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      return true;
    },
    
    // 发送手机验证码
    async sendcodeMsg({ captchaVerification }) {
      if (!captchaVerification) {
        return;
      }

      // 校验手机号格式
      if (!this.validatePhoneNumber()) {
        return;
      }

      this.setLoading(true);
      // 根据配置选择接口
      let url = this.$cloudflareVerify 
        ? `/customer/atClient/smsSendCloudFlare`
        : `/customer/atClient/smsSend`;
      if (this.secondSend > 0) {
        url = this.$cloudflareVerify
          ? `/customer/atClient/smsSendTextlocalCloudFlare`
          : `/customer/atClient/smsSendTextlocal`;
      }
      
      try {
        const res = await postGateway({
          url: url,
          method: 'POST',
          data: {
            phone: this.form.code + this.form.phone.trim(),
            captchaType: 'register',
            captchaVerification
          }
        });

        this.setLoading(false);
        if (res.code == 200) {
          this.handleSmsSuccess();
          this.secondSend++;
          this.$message({
            message: 'Verification sent successfully',
            type: 'success',
            offset: 50
          });
          this.startCountdown();
        }
      } catch (err) {
        this.$message.error(err.msg || 'Failed to send verification code');
        this.setLoading(false);
      }
    },
    
    // 处理登录成功
    handleLoginSuccess(data) {
      // 保存token
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('clientId', data.clientId);
      localStorage.setItem('aeClient', data.clientId);
      
      // 通知header登录成功
      bus.$emit('login');
      
      // 触发登录成功事件
      this.$emit('loginSuccess', data);
    },
    
    // 处理短信发送成功
    handleSmsSuccess() {
      this.$emit('smsSuccess');
    },
    
    // 关闭 Cloudflare 弹层
    closeCloudflare() {
      this.showCloudflare = false;
      this.setLoading(false); // 取消loading状态
      this.resetCode();
    },
    
    // Cloudflare token接收
    onTokenReceived(token) {
      this.sendcodeMsg({ captchaVerification: token });
      this.closeCloudflare();
    },
    
    // 显示忘记密码弹窗
    showForgotPassword() {
      this.showForgotPasswordModal = true;
    },
    
    // 关闭忘记密码弹窗
    closeForgotPassword() {
      this.showForgotPasswordModal = false;
    },
    
    // 跳转到注册页面
    goToSignup() {
      this.$router.push({
        path: '/signup',
        query: { from: this.fromPage }
      });
    },
    
    gotCode() {
      if (!this.form.phone.trim()) {
        this.$message({
          message: "Please enter phone number",
          type: "warning",
        });
        return;
      }
      if (this.form.phone.indexOf(44) === 0) {
        this.$message({
          message: "Without the '44' country code.",
          type: "warning",
        });
        return;
      }
      this.$emit('gotCode');
    },
    
    // 倒计时相关
    startCountdown() {
      this.num = 60;
      this.canGetCode = false;
      this.sendPhonecode = 'After ' + this.num + ' seconds retry';
      
      const timer = setInterval(() => {
        this.num--;
        this.sendPhonecode = 'After ' + this.num + ' seconds retry';
        if (this.num == 0) {
          this.sendPhonecode = 'Resend Code';
          this.canGetCode = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    
    resetCode() {
      this.num = 0;
      this.canGetCode = true;
      this.sendPhonecode = 'Send Verification Code';
    },
    
    // 设置加载状态
    setLoading(loading) {
      // 子组件可以重写此方法
      console.log('Loading state:', loading);
    },
    
    // 设置登录加载状态
    setLoginLoading(loading) {
      this.loginLoading = loading;
    },
    
    
    // 处理Google登录成功
    handleGoogleLoginDone() {
      // 传递给父组件
      this.$emit('loginSuccess');
    },
    
    // 处理Facebook登录成功
    handleFacebookLoginDone() {
      // 传递给父组件
      this.$emit('loginSuccess');
    },
    
    // 处理Apple登录成功
    handleAppleLoginDone() {
      // 传递给父组件
      this.$emit('loginSuccess');
    },
    
    // 处理需要绑定手机号
    handleNeedBindPhone() {
      // 发出需要绑定手机号的事件
      this.$emit('needBindPhone');
    },
    
    // 处理需要替代登录方式
    handleNeedAlternativeLogin(data) {
      // 显示提示信息，指导用户使用其他登录方式
      this.$message({
        type: 'info',
        message: `Please use your original login method to link your ${data.pendingCredential?.providerId === 'facebook.com' ? 'Facebook' : 'Google'} account.`,
        duration: 5000
      });
    },
    
    // 切换到注册表单
    switchToSignup() {
      this.formMode = 'signup';
    },
    
    // 切换到登录表单
    switchToLogin() {
      this.formMode = 'login';
    },
    
    // 处理注册成功
    handleSignupSuccess() {
      // 传递给父组件
      this.$emit('loginSuccess');
    }
  }
}
</script>

<style lang="scss" scoped>
.login-form {
  width: 100%;
  
  .form-header {
    text-align: center;
    margin-bottom: 40px;
    
    h2 {
      font-weight: 800;
      color: #000;
      font-size: 24px;
      margin: 0 0 8px 0;
    }
    
    p {
      font-size: 16px;
      color: #111;
      margin: 0;
    }
  }

  .input-box {
    margin: 18px auto 0;
    display: flex;
    align-items: center;
    position: relative;
    width: 80%;

    .area-box {
      height: 56px;
      width: 114px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      margin-right: 10px;
      border-radius: 12px;
    }
    
    .input {
      height: 56px;
      flex: 1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding-left: 20px;
      font-size: 20px;
      font-weight: 600;
      &::placeholder {
        font-weight: 500;
      }
    }
    
    .shadow-box {
      flex: 1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      position: relative;
      
      &.full-width {
        flex: 1;
        margin-right: 0;
      }
      
      input {
        height: 56px;
        width: 100%;
        border: none;
        outline: none;
        padding-left: 20px;
        padding-right: 50px;
        font-size: 20px;
        font-weight: 600;
        background: transparent;
        &::placeholder {
          font-weight: 500;
        }
      }
      
      .password-toggle {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        font-size: 18px;
        color: #999;
        transition: all 0.3s ease;
        
        &:hover {
          color: #666;
          transform: translateY(-50%) scale(1.1);
        }
        
        &:active {
          transform: translateY(-50%) scale(0.95);
        }
        
        &.show {
          color: #09ca6a;
          
          &:hover {
            color: #08b35e;
          }
        }
      }
    }
  }

  // 登录方式选择器样式
  .login-method-selector {
    display: flex;
    margin: 20px 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    
    .method-option {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background: #f8f9fa;
      cursor: pointer;
      transition: all 0.3s ease;
      border-right: 1px solid #e9ecef;
      
      &:last-child {
        border-right: none;
      }
      
      i {
        margin-right: 8px;
        font-size: 18px;
        color: #666;
      }
      
      span {
        font-size: 16px;
        font-weight: 500;
        color: #666;
      }
      
      &.active {
        background: #09CA6A;
        color: white;
        
        i, span {
          color: white;
        }
      }
      
      &:hover:not(.active) {
        background: #e9ecef;
      }
    }
  }

  .check-box {
    margin-top: 20px;
    display: flex;
    font-size: 18px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    :deep(.el-checkbox__inner) {
      background-color: #dcdfe6;
    }
    :deep(
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner
      ) {
      background-color: #09ca6a;
      border-color: #09ca6a;
    }
    :deep(.el-checkbox__inner) {
      transform: scale(1.4);
    }
    span {
      margin-left: 15px;
      cursor: pointer;
    }
    p {
      margin-top: 10px;
      display: block;
      font-size: 14px;
      line-height: 20px;
      color: #474747;
      text-align: left;
      .under-line {
        text-decoration: underline;
        margin: 0;
        cursor: pointer;
        color: #2885e2;
      }
    }
  }
  
  @keyframes shakingAnimation {
    0% {
      transform: translateX(-3%); 
      color: red;
    }
    10% {
      transform: translateX(63); 
      color: red;
    }
    20% {
      transform: translateX(-2%); 
      color: red;
    }
    30% {
      transform: translateX(2%); 
      color: red;
    }
    40% {
      transform: translateX(-1%); 
      color: red;
    }
    50% {
      transform: translateX(1%); 
    }
  }
  
  .shaking {
    color: rgb(199, 12, 12);
    transform: translateX(0); 
    animation: shakingAnimation 1s ease-in-out forwards;
  }
  
  .sign-btn {
    margin: 32px auto 5px;
    height: 58px;
    width: 240px;
    background-color: #09CA6A;
    color: #fff;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 600;
    border-radius: 29px;
    box-shadow: 0 4px 12px rgba(9, 202, 106, 0.3);
    transition: all .3s ease;
    cursor: pointer;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #0fda74;
      box-shadow: 0 6px 20px rgba(9, 202, 106, 0.4);
      transform: translateY(-2px);
    }
    &:active {
      transform: translateY(0);
    }
  }
  
  .being-send {
    height: 28px;
    font-size: 15px;
    margin: 10px auto 0;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
    display: block;
    &:active {
      color: #6f7577;
    }
  }
  
  // 底部链接容器
  .bottom-links-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .forgot-password-link {
    font-size: 12px;
    margin-top: 12px;
    text-decoration: underline;
    cursor: pointer;
    color: #2885e2;
    transition: color 0.3s ease;
    position: absolute;
    right: 0;
    bottom: -20px;
    white-space: nowrap;
    
    &:hover {
      color: #1a6bb8;
    }
    
    &:active {
      color: #0f4a7a;
    }
  }
  
  .signup-link-container {
    text-align: center;
    font-size: 14px;
    color: #666;
    
    .signup-link {
      color: #d22f21;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      margin-left: 5px;
      
      &:hover {
        color: #b01e1a;
      }
    }
  }
  
  .terms-notice {
    text-align: center;
    font-size: 12px;
    color: #999;
    margin-top: 15px;
    line-height: 1.4;
    
    .under-line {
      color: #2885e2;
      text-decoration: underline;
      cursor: pointer;
      
      &:hover {
        color: #1a6bb8;
      }
    }
  }
  
  // 社交登录区域样式
  .social-login-section {
    margin-top: 20px;
    width: 100%;
    
    .divider {
      display: flex;
      align-items: center;
      margin-top: 20px;
      
      &::before,
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #e0e0e0;
      }
      
      span {
        padding: 0 15px;
        color: #999;
        font-size: 14px;
        background: #fff;
      }
    }
    
    .social-login-buttons {
      display: flex;
      flex-direction: column;
      gap: 12px;
      
      // 移动端也保持垂直布局
      @media (max-width: 768px) {
        flex-direction: column;
        gap: 12px;
      }
    }
  }
  
  .disable-btn {
    background-color: #999;
    &:hover {
      background-color: #999;
      box-shadow: 0px 5px 10px #6f7577;
    }
  }
}

// Cloudflare 弹层样式
.cloudflare-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  .cloudflare-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
  }
  
  .cloudflare-content {
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    max-width: 480px;
    width: 100%;
    max-height: 85vh;
    overflow: hidden;
    animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
    
    .cloudflare-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 28px;
      border-bottom: 1px solid #e9ecef;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        display: flex;
        align-items: center;
      }
      
      .close-btn {
        background: none;
        border: none;
        font-size: 22px;
        color: #6c757d;
        cursor: pointer;
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        
        &:hover {
          background: #e9ecef;
          color: #495057;
          transform: scale(1.1);
        }
      }
    }
    
    // Cloudflare 组件容器
    :deep(.cloudflare-verify) {
      padding: 24px 28px 28px;
      text-align: center;
      
      .cloudflare-widget {
        margin: 0 auto;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(-30px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

// 移动端适配
@media screen and (max-width: 950px) {
  .login-form {
    .form-header {
      h2 {
        font-size: 18px;
      }
      p {
        font-size: 14px;
      }
    }
    
    .input-box {
      margin-top: 20px;
      width: 100%;
      .area-box {
        height: 50px;
      }
      .shadow-box {
        input {
          box-shadow: unset;
          height: 50px;
          width: 100%;
          font-size: 16px;
        }
      }
    }
    
    .login-method-selector {
      margin: 15px 0;
      
      .method-option {
        padding: 12px 15px;
        
        i {
          font-size: 16px;
          margin-right: 6px;
        }
        
        span {
          font-size: 14px;
        }
      }
    }
    
    .sign-btn {
      width: 80%!important;
      margin: 32px auto 0!important;
      height: 48px;
      font-size: 20px;
    }
    
    .being-send {
      margin: 10px auto 0!important;
    }
    
    .forgot-password-link {
      font-size: 11px;
      bottom: -18px;
    }
  }
}
</style>
